import { IAppTheme } from '@msx/platform-services'
import { IStyle } from '@fluentui/react';

export interface IAppStyles {
  root: IStyle;
  main: IStyle;
  skipToMainContentLink: IStyle;
}

export const getStyles = (theme: IAppTheme): IAppStyles => {
  return {
    root: {
    },
    main: {
      outline: 'none',
      minHeight: 'calc(100vh - 48px)', // Full viewport height minus header height
      display: 'flex',
      flexDirection: 'column',
      flex: '1',
      width: '100%',
      position: 'relative',
    },
    skipToMainContentLink: {
      fontSize: '14px',
      fontWeight: '600',
      outline: 'none',
      textDecoration: 'underline',
      width: '100%',
      height: '48px',
      lineHeight: '48px',
      textAlign: 'center',
      position: 'absolute',
      top: '-100px',
      zIndex: 1000,
      color: theme.palette.themePrimary,
      backgroundColor: theme.palette.neutralLighter,
      selectors: {
        ':focus': {
          top: '0px',
          boxShadow: `${theme.palette.neutralTertiary} 0px 0px 0px 1px inset`,
          outlineColor: theme.palette.neutralTertiary,
          outlineStyle: 'auto',
          outlineWidth: '1px',
        }
      }
    },
  }
};


